import styled from 'styled-components';

export const DetailWrapper = styled.div``;
export const LabelWrapper = styled.div`
  display: flex;

  gap: 0.25rem;
`;
export const InputLabel = styled.label`
  display: inline-block;
  margin-bottom: 0.25rem;
  color: #000;
`;
